"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = exports.ConfigurationOptions = exports.ConfigurationRow = exports.LocationConfiguration = exports.TreatmentConfiguration = exports.TimeConfiguration = exports.SampleConfiguration = void 0;
class SampleConfiguration {
    constructor(obj) {
        this.id = obj.id || -1;
        this.code = obj.code || '------';
    }
    downloadBCReport() {
        // Download the report
        window.open(`/report/pdf/${this.code}`, '_blank');
        //window.location.href =
    }
    hasMatchingSearch(key) {
        if (key.includes(',') || key.includes(' ') || key.includes('|')) {
            const chunks = key.split(/[\s,|]+/);
            for (const chunk of chunks) {
                if (this.code.toLowerCase().includes(chunk.toLowerCase())) {
                    return true;
                }
            }
        }
        else {
            return this.code.toLowerCase().includes(key.toLowerCase()) ? true : false;
        }
        return false;
    }
}
exports.SampleConfiguration = SampleConfiguration;
class TimeConfiguration {
    constructor(obj) {
        this.date = obj.date || '-';
        this.time = obj.time || 0;
        this.order = obj.order || 0;
        this.label = obj.label || this.time.toString();
        this.samples = obj.samples || new Array();
        this.samplesTotalThisTime = obj.samplesTotalThisTime || -1;
        this.samplesAssignedForTime = obj.samplesAssignedForTime || -1;
        this.lineage = obj.lineage || '-';
        this.downloadProgress = obj.downloadProgress || -1;
    }
    get hook() {
        let hook = 'T' + this.time + ' ' + this.date + ' ';
        for (let sample of this.samples) {
            hook += sample.code + ' ';
        }
        return hook.toLowerCase();
    }
    get ownHook() {
        let hook = 'T' + this.time + ' ' + this.date + ' ';
        return hook.toLowerCase();
    }
    get samplesInside() {
        return this.samples;
    }
    isSampleIncluded(code) {
        return this.hook.includes(code) ? true : false;
    }
    hasMatchingSearch(key) {
        if (key.includes(',') || key.includes(' ') || key.includes('|')) {
            const chunks = key.split(/[\s,|]+/);
            for (const chunk of chunks) {
                if (this.hook.includes(chunk.toLowerCase())) {
                    return true;
                }
            }
        }
        else {
            return this.hook.includes(key.toLowerCase()) ? true : false;
        }
        return false;
    }
    hasOwnMatch(key) {
        if (key.includes(',') || key.includes(' ') || key.includes('|')) {
            const chunks = key.split(/[\s,|]+/);
            for (const chunk of chunks) {
                if (this.ownHook.includes(chunk.toLowerCase())) {
                    return true;
                }
            }
        }
        else {
            return this.ownHook.includes(key.toLowerCase()) ? true : false;
        }
        return false;
    }
    async downloadReports() {
        // Descargar todos los reportes
        // console.log('reportes ' + this.time)
        /*
        this.downloadInfo.downloading = true;
        this.downloadInfo.donutMax = this.samples.length;
        const zipname = 'Samples_' + this.finish_day + '.zip';

        const zip = new Zip();

        for (const [i, sample] of this.samples.entries()) {
            this.downloadInfo.donutCurrent = i + 1;
            const url = '/report/pdf/' + sample.code;
            await zip.addURL(url);
        }

        await zip.download(zipname);

        this.downloadInfo.downloading = false; */
        /*         const zipname = `T${this.time}.zip`;

        const zip = new Zip();

        const fakeSamples = [{code: 'CI348A'}, {code: 'CI348B'}, {code: 'CI348C'}]

        this.downloadProgress = 0;
        for (const [i, sample] of fakeSamples.entries()) {
            //this.downloadInfo.donutCurrent = i + 1;
            this.downloadProgress = (100 / fakeSamples.length) * (i + 1)
            const url = '/report/pdf/' + sample.code;
            await zip.addURL(url);
        }

        this.downloadProgress = 100
        await zip.download(zipname); */
    }
    resetDownloadProgress() {
        this.downloadProgress = 0;
    }
}
exports.TimeConfiguration = TimeConfiguration;
class TreatmentConfiguration {
    constructor(obj) {
        this.name = obj.name || '-';
        this.label = obj.label || this.name;
        this.id = obj.id || -1;
        this.is_control = obj.is_control || false;
        this.type = obj.type || '-';
        this.times = obj.times || new Array();
        this.lineage = obj.lineage || '-';
    }
    get hook() {
        let hook = this.name + ' ' + this.type + ' ';
        for (let time of this.times) {
            hook += 'T' + time.time + ' ' + time.date + ' ';
            for (let sample of time.samples) {
                hook += sample.code + ' ';
            }
        }
        return hook.toLowerCase();
    }
    get ownHook() {
        let hook = this.name + ' ' + this.type + ' ';
        return hook.toLowerCase();
    }
    get samplesInside() {
        let samples = [];
        for (let time of this.times) {
            samples = [...samples, ...time.samplesInside];
        }
        return samples;
    }
    isSampleIncluded(code) {
        return this.hook.includes(code) ? true : false;
    }
    hasMatchingSearch(key) {
        if (key.includes(',') || key.includes(' ') || key.includes('|')) {
            const chunks = key.split(/[\s,|]+/);
            for (const chunk of chunks) {
                if (this.hook.includes(chunk.toLowerCase())) {
                    return true;
                }
            }
        }
        else {
            return this.hook.includes(key.toLowerCase()) ? true : false;
        }
        return false;
    }
    hasOwnMatch(key) {
        if (key.includes(',') || key.includes(' ') || key.includes('|')) {
            const chunks = key.split(/[\s,|]+/);
            for (const chunk of chunks) {
                if (this.ownHook.includes(chunk.toLowerCase())) {
                    return true;
                }
            }
        }
        else {
            return this.ownHook.includes(key.toLowerCase()) ? true : false;
        }
        return false;
    }
    downloadReports() {
        // Descargar todos los reportes
        // console.log('reportes ' + this.name)
    }
}
exports.TreatmentConfiguration = TreatmentConfiguration;
class LocationConfiguration {
    constructor(obj) {
        this.id = obj.id || -1;
        this.name = obj.name || '-';
        this.label = obj.label || this.name;
        this.crop = obj.crop || '-';
        this.treatments = obj.treatments || new Array();
        this.lineage = obj.lineage || this.name;
    }
    get isReusingSamples() {
        const treatments = this.treatments;
        const controlSamples = treatments
            .find((treatment) => treatment.is_control)
            .times.find((time) => time.time === 0)
            .samples
            .filter((rawSample) => !rawSample.code.includes('-'))
            .map((sample) => sample.code);
        return treatments.some((treatment) => treatment !== treatments.find((t) => t.is_control) &&
            treatment.times.some((time) => time.time === 0 && time.samples.some((sample) => controlSamples.includes(sample.code))));
    }
    get hook() {
        let hook = this.name + ' ' + this.crop + ' ';
        for (let treatment of this.treatments) {
            hook += treatment.name + ' ' + treatment.type + ' ';
            for (let time of treatment.times) {
                hook += 'T' + time.time + ' ' + time.date + ' ';
                for (let sample of time.samples) {
                    hook += sample.code + ' ';
                }
            }
        }
        return hook.toLowerCase();
    }
    get ownHook() {
        let hook = this.name + ' ' + this.crop + ' ';
        return hook.toLowerCase();
    }
    get samplesInside() {
        let samples = [];
        for (let treatment of this.treatments) {
            samples = [...samples, ...treatment.samplesInside];
        }
        return samples;
    }
    isSampleIncluded(code) {
        return this.hook.includes(code) ? true : false;
    }
    hasMatchingSearch(key) {
        if (key.includes(',') || key.includes(' ') || key.includes('|')) {
            const chunks = key.split(/[\s,|]+/);
            for (const chunk of chunks) {
                if (this.hook.includes(chunk.toLowerCase())) {
                    return true;
                }
            }
        }
        else {
            return this.hook.includes(key.toLowerCase()) ? true : false;
        }
        return false;
    }
    hasOwnMatch(key) {
        if (key.includes(',') || key.includes(' ') || key.includes('|')) {
            const chunks = key.split(/[\s,|]+/);
            for (const chunk of chunks) {
                if (this.ownHook.includes(chunk.toLowerCase())) {
                    return true;
                }
            }
        }
        else {
            return this.ownHook.includes(key.toLowerCase()) ? true : false;
        }
        return false;
    }
    downloadReports() {
        // Descargar todos los reportes
        console.log('reportes ' + this.name);
    }
}
exports.LocationConfiguration = LocationConfiguration;
class ConfigurationRow {
    constructor(obj) {
        this.location = obj.location || '-';
        this.treatment = obj.treatment || '-';
        this.time = obj.time || '-';
        this.sample = obj.sample || new SampleConfiguration({ id: -1, code: '' });
    }
    get hook() {
        return (this.location + ' ' + this.treatment + ' ' + this.time + ' ' + this.sample.code).toLowerCase();
    }
}
exports.ConfigurationRow = ConfigurationRow;
class ConfigurationOptions {
    constructor(obj) {
        this.location = obj.location || '-';
        this.treatment = obj.treatment || '-';
        this.time = obj.time || '-';
        this.configurationRows = obj.configurationRows || new Array();
    }
}
exports.ConfigurationOptions = ConfigurationOptions;
class Configuration {
    constructor(obj) {
        this.locations = obj.locations || new Array();
    }
    get hasReusingSamples() {
        return this.locations.some((location) => location.isReusingSamples);
    }
    get treatments() {
        const myTreatments = [];
        for (let location of this.locations) {
            for (let treatment of location.treatments) {
                myTreatments.push(treatment);
            }
        }
        let uniqueArray = myTreatments.filter((value, index) => {
            const name = value.name;
            return (index ===
                myTreatments.findIndex((obj) => {
                    return obj.name === name;
                }));
        });
        return uniqueArray;
    }
    get times() {
        const myTimes = [];
        for (let location of this.locations) {
            for (let treatment of location.treatments) {
                for (let time of treatment.times) {
                    myTimes.push(time);
                }
            }
        }
        let uniqueArray = myTimes.filter((value, index) => {
            const time = value.time;
            return (index ===
                myTimes.findIndex((obj) => {
                    return obj.time === time;
                }));
        });
        return uniqueArray;
    }
    get samplesInside() {
        let samples = [];
        for (let location of this.locations) {
            samples = [...samples, ...location.samplesInside];
        }
        return samples;
    }
    get configurationRows() {
        let configurationRows = [];
        for (let location of this.locations) {
            for (let treatment of location.treatments) {
                for (let time of treatment.times) {
                    for (let sample of time.samples) {
                        configurationRows.push(new ConfigurationRow({
                            location: location.name,
                            treatment: treatment.name,
                            time: 'T' + time.time,
                            sample: sample,
                        }));
                    }
                }
            }
        }
        return configurationRows;
    }
    rowifyCustomConfiguration(locIndex, treatIndex, timeIndex) {
        let configurationRows = [];
        if (locIndex === -1) {
            return this.configurationRows;
        }
        else {
            if (treatIndex === -1) {
                for (let treatment of this.locations[locIndex].treatments) {
                    // Todas las treat
                    for (let time of treatment.times) {
                        for (let sample of time.samples) {
                            configurationRows.push(new ConfigurationRow({
                                location: this.locations[locIndex].name,
                                treatment: treatment.name,
                                time: 'T' + time.time,
                                sample: sample,
                            }));
                        }
                    }
                }
            }
            else {
                if (timeIndex === -1) {
                    for (let time of this.locations[locIndex].treatments[treatIndex].times) {
                        // Todos los times
                        for (let sample of time.samples) {
                            configurationRows.push(new ConfigurationRow({
                                location: this.locations[locIndex].name,
                                treatment: this.locations[locIndex].treatments[treatIndex].name,
                                time: 'T' + time.time,
                                sample: sample,
                            }));
                        }
                    }
                }
                else {
                    for (let sample of this.locations[locIndex].treatments[treatIndex].times[timeIndex].samples) {
                        configurationRows.push(new ConfigurationRow({
                            location: this.locations[locIndex].name,
                            treatment: this.locations[locIndex].treatments[treatIndex].name,
                            time: 'T' + this.locations[locIndex].treatments[treatIndex].times[timeIndex].time,
                            sample: sample,
                        }));
                    }
                }
            }
        }
        return configurationRows;
    }
    simpleSamplesInsideCustomBulk(locIx, treatIx, timeIx) {
        return this.locations[locIx].treatments[treatIx].times[timeIx].samplesInside;
    }
    samplesInsideCustomBulk(locIx, treatIx, timeIx) {
        let samplesInside = [];
        for (let i of locIx) {
            for (let j of treatIx) {
                for (let k of timeIx) {
                    samplesInside = [...samplesInside, ...this.simpleSamplesInsideCustomBulk(i, j, k)];
                }
            }
        }
        return samplesInside;
        /*         if(locIx.length === this.locations.length) {
            // All Locations
            if(treatIx.length === this.treatments.length) {
                // All Treatments
                if(timeIx.length === this.times.length) {
                    // All Times
                    samplesInside = this.samplesInside
                } else {
                    for (let k of timeIx) {
                        // Tiempo Especifico
                        samplesInside = [...samplesInside, this.locations[]]
                    }
                }
            } else {
                for (let j of treatIx) {
                    // Tratamiento especifico
                    if(timeIx.length === this.times.length) {
                        // Todos sus tiempos
                    } else {
                        for (let k of timeIx) {
                            // Tiempo Especifico
                        }
                    }
                }
            }
        } else {
            for(let i of locIx) {
                // Localizacion concreta
                if(treatIx.length === this.treatments.length) {
                    // All Treatments
                    if(timeIx.length === this.times.length) {
                        // All Times
                    } else {
                        for (let k of timeIx) {
                            // Tiempo Especifico
                        }
                    }
                } else {
                    for (let j of treatIx) {
                        // Tratamiento especifico
                        if(timeIx.length === this.times.length) {
                            // Todos sus tiempos
                        } else {
                            for (let k of timeIx) {
                                // Tiempo Especifico
                            }
                        }
                    }
                }
            }
        } */
    }
}
exports.Configuration = Configuration;
